export var STOPPED = 'STOPPED';
export var PLAYING = 'PLAYING';
export var RECORDING = 'RECORDING';
